import { compose, prop, mapProp, valueOr } from './fp'

export const connectionNodes = compose(
  mapProp('node'),
  prop('edges'),
  valueOr({ edges: [] })
)



// WEBPACK FOOTER //
// ./src/utils/relay.js